import { render, staticRenderFns } from "./VideoRequest.vue?vue&type=template&id=57b6fedb&"
import script from "./VideoRequest.vue?vue&type=script&lang=js&"
export * from "./VideoRequest.vue?vue&type=script&lang=js&"
import style0 from "./VideoRequest.vue?vue&type=style&index=0&id=57b6fedb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports